export type UserState = {
    user: User,
    token: string,
    isLogged?: boolean,
    isLoading?: boolean,
}

export type User = {
    username: string;
    auth_key: string;
    created_at: number;
    email: string;
    last_login: number;
    profile: Profile,
    roles: RoleUser[],
}

export type Profile = {
    address: string;
    bank_details: string;
    biography: string;
    blood_group: string;
    department_id: number;
    designation_id: number;
    dob: string;
    doh: string;
    first_name: string;
    gender: number;
    job_title: string;
    last_name: string;
    mobile_no: string;
};

export type RoleUser = {
    id: number;
    role_id: number;
    user_id: number;
    user_type: number;
};

export const initialState: UserState = {
    token: '',
    user: {
        username: '',
        auth_key: '',
        created_at: 0,
        email: '',
        last_login: 0,
        profile: {
            address: '',
            bank_details: '',
            biography: '',
            blood_group: '',
            department_id: 0,
            designation_id: 0,
            dob: '',
            doh: '',
            first_name: '',
            gender: 0,
            job_title: '',
            last_name: '',
            mobile_no: '',
        },
        roles: [{
                id: 0,
                role_id: 0,
                user_id: 0,
                user_type: 0,
            }],
    },
    isLogged: false,
    isLoading: false,
}